import axios from "axios"

const URL =
  "https://my-json-server.typicode.com/yash0patni/issue_tracker_server"

class UserApi {
  static async loginUser(user, cb) {
    try {
      const res = await axios.get(`${URL}/users/${user.id}`)
      if (user.password === res.data.password) {
        cb(res.data)
      } else {
        cb({ error: "Password is incorrect" })
      }
    } catch (err) {
      cb({ error: "Email id doesn't exist, please check or signup" })
    }
  }

  static async signupUser(user, cb) {
    try {
      const res = await axios.post(`${URL}/users`, user, {
        "Content-Type": "application/json",
      })
      cb(res.data)
    } catch (err) {
      cb({ error: "Email id already in use or Already registered" })
    }
  }
}

export default UserApi
